import React, { Fragment, useCallback, useEffect, useState } from "react";
import Input from "../../../components/Input/Input";
import { recoverPwd, setAuthLoading, setSessionUser, setUser } from "../../../Reducers/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/Icon/Icon";
import { supabase } from "../../../../supabase";
// import { supabase } from "../../../../supabase";
import "./ChangePwd.scss"
import { RecoverIcon } from "../../Auth/RecoverPwd";

const ChangePwd = () => {
    const user = useSelector((state) => state.auth?.user || {})

    const [loading, setLoading] = useState(false)
    const [showPwd, setShowPwd] = useState(false)
    const [showOldPwd, setShowOldPwd] = useState(false)
    const [showPwdConfirm, setShowPwdConfirm] = useState(false)
    const [oldPwd, setOldPwd] = useState("")
    const [password, setPassword] = useState("");
    const [pwdConfirm, setPwdConfirm] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)
    const [error, setError] = useState(null)
    const [reset, setReset] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const validateForm = useCallback(() => {
        // const newErrors = {};
        const BreakException = {}
        try {
            if (!(oldPwd && oldPwd.length > 0)) {
                setErrorMessage("Password Confirmation is required.")
                throw BreakException
            }

            if (!(password && password.length > 0)) {
                setErrorMessage("Password is required.")
                throw BreakException
            }
            if (!(pwdConfirm && pwdConfirm.length > 0)) {
                setErrorMessage("Password Confirmation is required.")
                throw BreakException
            }

            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
            if (oldPwd && !passwordRegex.test(oldPwd)) {
                setErrorMessage("Old password is required.")
                throw BreakException

            }

            if (password && !passwordRegex.test(password)) {
                setErrorMessage("Password must be at least 8 characters long, with at least 1 uppercase, 1 lowercase, and 1 special character.")
                throw BreakException

            }

            if (password !== pwdConfirm) {
                setErrorMessage("Passwords do not match.")
                throw BreakException
            }
            setErrorMessage(null)
        } catch (e) {
            if (e !== BreakException) console.log(e)
        }
    }, [password, pwdConfirm, oldPwd]);

    useEffect(() => {
        validateForm()
    }, [password, pwdConfirm, oldPwd, validateForm])


    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (!errorMessage) {
            dispatch(setAuthLoading(true))
            recoverPwd(password, pwdConfirm, user?.email, oldPwd).then(async ({ success, data, message }) => {
                if (success) {
                    setLoading(false)
                    setReset(true)
                    if (data?.session) {
                        dispatch(setSessionUser(data.session))
                        const { data: dataAuth, error } = await supabase.auth.signInWithPassword({
                            email: user.email,
                            password
                        })
                        if (error) {
                            dispatch(setSessionUser(null))
                            dispatch(setUser(null))
                            dispatch(setAuthLoading(false))
                            navigate("/profile")
                        } else {
                            const { data, error } = await supabase.auth.setSession({
                                access_token: dataAuth.session.access_token,
                                refresh_token: dataAuth.session.refresh_token,
                            });
                            if (data || error) dispatch(setAuthLoading(false))
                        }


                        // const { data: updated } = await supabase.auth.getSession();
                        // if (updated?.session) {
                        //     dispatch(setSessionUser(updated.session));
                        // }
                    }
                } else {
                    setLoading(false)
                    setError("Wrong password, try something else.")
                }
            })
        }
    }


    const handleGoToLogin = async () => {
        await supabase.auth.signOut();
        dispatch({
            type: 'RESET_USER'
        })
        dispatch({
            type: 'RESET_SESSION'
        })
        localStorage.removeItem("email")
        localStorage.removeItem("pdp")
        navigate("/login");
    }
    return (
        <div className="px-16 pb-16 d-flex f-column aic">
            {!reset && <div className="change-header d-flex aic">
                <div className="nav-icon p-absolute" onClick={() => navigate(-1)} style={{ left: '16px' }}>
                    <Icon alias={"chevron-left"} stroke={"#0A0F1E"} color="#222" width={24} />
                </div>
                <p className="fs-sm2 fw-medium-bold mt-8">CHANGE PASSWORD</p>
            </div>}
            <div className="auth-container pt-12 w-full">
                {reset
                    ?
                    <div className="d-flex f-column aic mt-40 pt-40 px-8">
                        {/* <img src="verify_circle.png" width={200} className="my-40" alt="Verify Circle" /> */}
                        <RecoverIcon />
                        <p className="fg-dark fs-sm2 fw-bold mb-16">Password changed!</p>
                        <p className="fg-grey7 fw-medium ta-center">You've successfully reset your password, you can now login to your account.</p>
                        <div className="mt-32">
                            <button onClick={() => handleGoToLogin()} className="btn red-btn btn-full-v d-flex aic jcc p-relative" >
                                LOGIN
                                <Icon className={'p-absolute'} alias={"arrow-right"} color={"#FFF"} stroke={"#FFF"} width={24} style={{ right: '16px' }} />
                            </button>
                        </div>
                    </div>
                    : <Fragment>
                        {/* <p className='fg-black fs-md fw-medium-bold mb-40 mt-0'>Set new password</p> */}
                        <form onSubmit={handleUpdatePassword} className="w-full">
                            <div className={`input-container ${error ? 'mb-0' : 'mb-16'}`}>
                                <input
                                    type={showOldPwd ? "text" : "password"}
                                    value={oldPwd}
                                    onChange={(e) => { setOldPwd(e.target.value); setError(null) }}
                                    placeholder="Current password"
                                    className="input-main w-full"
                                />
                                <div className="input-icon" onClick={() => setShowOldPwd(prev => !prev)}>
                                    <Icon alias={"show-password"} width={24} color="#777777" />
                                </div>
                            </div>
                            {error &&
                                <p className="fs-real fw-medium fg-xtred ta-center mt-8">
                                    {error}
                                </p>}
                            <div className="input-container mb-16">
                                <input
                                    type={showPwd ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="New password"
                                    className="input-main w-full"
                                />
                                <div className="input-icon" onClick={() => setShowPwd(prev => !prev)}>
                                    <Icon alias={"show-password"} width={24} color="#777777" />
                                </div>
                            </div>
                            <div className="input-container mb-12">
                                <input
                                    type={showPwdConfirm ? "text" : "password"}
                                    value={pwdConfirm}
                                    onChange={(e) => setPwdConfirm(e.target.value)}
                                    placeholder="Confirm password"
                                    className="input-main w-full"
                                />
                                <div className="input-icon" onClick={() => setShowPwdConfirm(prev => !prev)}>
                                    <Icon alias={"show-password"} width={24} color="#777777" />
                                </div>
                            </div>
                            <p className={`fg-black fs-real fw-medium mt-4 ${errorMessage ? 'fg-xtred' : ''}`}>Passwords must be at least 8 characters long, with at least 1 upper case, 1 lower case and 1 special character.</p>

                            <div className='p-fixed' style={{ bottom: '24px' }}>
                                <button type="submit" className="btn red-btn btn-full-v d-flex aic jcc p-relative" disabled={loading || !!errorMessage} >
                                    {loading ? "Updating password..." : "Continue"}
                                    <Icon className={'p-absolute'} alias={"arrow-right"} color={"#FFF"} stroke={"#FFF"} width={24} style={{ right: '16px' }} />
                                </button>
                            </div>
                        </form>
                    </Fragment>
                }
            </div>
        </div>
    )
}

export default ChangePwd